import { Header } from "./components/Header/Header.tsx";
import { MenuDrawer } from "./components/MenuDrawer/MenuDrawer.tsx";
import "./Layout.scss";
import { AppSettingsProvider } from "~context/AppSettingsContext/AppSettingsContext.tsx";
import { NotificationCountProvider } from "~context/NotificationCountContext/NotificationCountContext";
import { UserPermissionsProvider } from "~context/UserPermissionsContext";
import { Content } from "./components/Content/Content.tsx";

export const Layout = () => (
  <div className="app-layout">
    <AppSettingsProvider>
      <NotificationCountProvider>
        <UserPermissionsProvider>
          <Header />
          <MenuDrawer />
          <Content />
        </UserPermissionsProvider>
      </NotificationCountProvider>
    </AppSettingsProvider>
  </div>
);
